import util from '@bmp-vue/core/api/util'

const controller = 'Projeto'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetCustomJSON: function (codigo, isIdProjeto) {
    return util.Axios.Get(`${controller}/GetCustomJSON/${codigo}?isIdProjeto=${isIdProjeto}`);
  },
  PutCustomJSON: function (id, dto) {
    return util.Axios.Put(controller + '/PutCustomJSON', id, dto)
  },
  GetImagensProjeto: () => {
    return [
      { text: 'Fundo', value: 'background', regras: { extensao: ['image/svg+xml'], tamanho: 1, dimensao: { largura: 1800, altura: 950 } } },
      { text: 'Logo', value: 'logo', regras: { extensao: ['image/png', 'image/svg+xml'], tamanho: 1, dimensao: { largura: 1000, altura: 1000 } } },
      { text: 'Logo cores invertidas', value: 'logoInverted', regras: { extensao: ['image/png', 'image/svg+xml'], tamanho: 2, dimensao: { largura: 1000, altura: 1000 } } },
      { text: 'Ícone guia navegador', value: 'favicon', regras: { extensao: ['image/png', 'image/svg+xml'], tamanho: 1, dimensao: { largura: 500, altura: 500 } } },
    ];
  },
  GetCoresProjeto: () => {
    return [
      { variavel: 'primary', nome: 'Cor primária', cor: '#1F337D', editavel: true },
      { variavel: 'secondary', nome: 'Cor secundária', cor: '#F4F4F5', editavel: true },
    ];
  }
})
